// extracted by mini-css-extract-plugin
export default {"container":"TextCombo_container__MRFDR","label":"TextCombo_label__Vpox6","select":"TextCombo_select__Amfrj"};